<div>
  <div class="header-style">
    <div class="h-100 d-flex">
      @if (showSelect) {
        <mat-checkbox [checked]="allSelected" (change)="setAll($event.checked)" class="all-checkbox" i18n-aria-label aria-label="Select all"></mat-checkbox>
      }
      @if (showSelect) {
        <button i18n="@@sendMessage" data-testid="send_email_button" (click)="sendEmails()" mat-raised-button color="accent">Send message</button>
      }
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      <mat-icon data-testid="email_subscription_button" (click)="toggleSelect()" class="{{showSelect ? 'cursor add-icon header-email-icon' : 'email-color cursor add-icon header-email-icon'}}" i18n-aria-label aria-label="Email subscriptions">email</mat-icon>
      <mat-icon data-testid="add_subscription_button" (click)="openAddSubscription()" class="cursor add-icon"  svgIcon="add" aria-hidden="false" i18n-aria-label aria-label="Add Subscription"></mat-icon>
      
      @if (subscriptionsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportCSV" (click)="exportDistributerMobileAppSubscriptions(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportPDF" (click)="exportDistributerMobileAppSubscriptions(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportExcel" (click)="exportDistributerMobileAppSubscriptions(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportMenu" i18n-aria-label aria-label="Export"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="subscription_search_input" matInput formControlName="sponsorSearch" id="sponsorSearch" placeholder="Search" name="sponsorSearch"/>
            <mat-icon data-testid="subscription_clear_button" class="cursor" matSuffix (click)="clearSearch()" i18n-aria-label aria-label="Clear search">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="subscription_search_button" (click)="handleSearchClick()" class="cursor"  svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="Search"></mat-icon>
    </div>
  </div>
  @for (item of subscriptionsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
      <mat-card-content class="content-box">
        <div class="content flex-grow w-90">
          @if (showSelect) {
            <mat-checkbox (change)="onCheckChange(item, $event.checked)" [checked]="selectedNames.includes(item)" class="one-checkbox" i18n-aria-label aria-label="Select subscription"></mat-checkbox>
          }
          <div class="w-100">
            <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.firstName}} {{item.lastName}}</div>
            <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.promotionCodeId}}</div>
            @if (item.promotionCodeId !== 'Expired' || item.promotionCodeId !== 'No Code/No Expire Date') {
              <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{ diffDays(item.expiryDate)}}</div>
            }
          </div>
        </div>
        <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label aria-label="More options">more_vert</mat-icon>
        <mat-menu #menu="matMenu">
          <button i18n="@@sendMessage" data-testid="edit_button" (click)="sendEmail(item)" mat-menu-item>Send message</button>
          <button i18n="@@edit" data-testid="delete_button" (click)="edit(item.id, item)" mat-menu-item>Edit</button>
          @if (item.promotionCodeId == 'Expired' || item.promotionCodeId == 'No Code/No Expire Date') {
            <button i18n="@@renew" data-testid="delete_button" (click)="renew(item.id)" mat-menu-item>Renew</button>
          }
          <button i18n="@@delete" data-testid="delete_button" (click)="delete(item.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  }
  @if (subscriptionsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-aria-label aria-label="No subscriptions found">
  }
</div>
